import { DataVis_1 as DataVis1 } from '@carbon/icons-react';
import * as React from 'react';
import {
  Heading,
  Icon,
  LoadingIcon,
  StaticBadge,
} from 'vet-bones/design-system/components';

import * as copy from 'src/templates/copy';

export interface DataConnectionPanelHeaderProps {
  concepts: string[] | null;
  isGeneratingConcepts: boolean;
}

export const DataConnectionPanelHeader: React.VFC<
  DataConnectionPanelHeaderProps
> = ({ concepts, isGeneratingConcepts }) => (
  <div className="sd-data-connection-panel-header">
    <div className="sd-create-project-panel-header-text">
      <Heading size="2xl">
        {copy.components.createProjectOverlay.dataConnectionPanel.title}
        <span>
          {copy.components.createProjectOverlay.dataConnectionPanel.titleSpan}
        </span>
      </Heading>
      <Heading size="sm">
        {copy.components.createProjectOverlay.dataConnectionPanel.subtitle}
      </Heading>
    </div>
    <div className="sd-data-connection-panel-header-help">
      <div className="sd-data-connection-panel-header-help-title">
        <Icon IconComponent={DataVis1} size="md" />
        <Heading size="md">
          {copy.components.createProjectOverlay.dataConnectionPanel.concepts}
        </Heading>
      </div>
      <div className="sd-data-connection-panel-header-help-badges">
        {isGeneratingConcepts ? (
          <Icon IconComponent={LoadingIcon} size="sm" />
        ) : null}
        {concepts?.map((concept) => (
          <StaticBadge key={concept} size="md" type="info" variant="muted">
            {concept}
          </StaticBadge>
        ))}
      </div>
    </div>
  </div>
);
